<!-- Desktop dropdown -->
<div class="sm-desktop">
  <div class="sm-header">
    <div class="sm-avatar">
      <img
        [src]="
          profileInfo?.imgUrl || 'assets/sgs-dashboard/customer-profile.png'
        "
        alt=""
      />
    </div>
    <div class="sm-user-info">
      <span class="sm-name">{{ profileInfo?.name }}</span>
      <span class="sm-email">{{ profileInfo?.email }}</span>
    </div>
  </div>

  <div class="sm-body">
    <div class="sm-credits">
      <span translate>Credits</span>
      <span class="sm-credits-value">
        {{
          profileInfo?.availableAppCredit?.amount | numberTranslate
        }}&nbsp;<currency-symbol
          [type]="profileInfo?.availableAppCredit?.currency"
        ></currency-symbol>
      </span>
    </div>
    <button mat-menu-item (click)="profile()" appTrackClick="my-profile-btn">
      <div class="d-flex align-items-center gap-2">
        <mat-icon fontSet="material-icons-outlined">person</mat-icon>
        <span translate>My Profile</span>
      </div>
    </button>
  </div>

  <div class="sm-footer">
    <button
      mat-menu-item
      class="sm-logout"
      (click)="logout()"
      appTrackClick="logout-btn"
    >
      <div class="d-flex align-items-centera gap-2">
        <mat-icon fontSet="material-icons-outlined">exit_to_app</mat-icon>
        <span translate>Log Out</span>
      </div>
    </button>
  </div>
</div>
